import { Col, Row, Tabs } from "antd";
import React, { FC} from "react";
import styled from "styled-components";
import { Switch, Route, withRouter, useHistory } from "react-router-dom";
import FooterPublic3D from "../../../Components/FooterPublic3D";
import HeaderComponent from "../../../Components/HeaderComponents";
import InboxPage from "../InboxPage/InboxPage";
import AddNewPrinter from "../MyPrinters/AddNewPrinter";
import MyPrinters from "../MyPrinters/MyPrinters";
import OrderPageNew from "../OrderPage/OrderPageNew";
import MyDesigns from "../Designs/MyDesigns";
import SinglePrinterPage from "../MyPrinters/SinglePrinterPage";
import EditPrinter from "../MyPrinters/PrinterEdit";
import UploadNewDesignSelectPage from "../Designs/UploadNewDSP";
import ProfileScreen from "../Profile/ProfileScreen";
import UploadNewDesignPage from "../Designs/UploadNewDesignPage.";
import UploadNewPublish from "../Designs/UploadNewPublish";
import InfoPage from "../Designs/InfoPage";
import UploadDesignThumbnail from "../Designs/uploadDesignThumbnail";

const { TabPane } = Tabs;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 2rem;
  min-height: 100vh;
`;
const SubHeaderSection = styled(Row)`
  margin: 3rem 0 2rem 0;
  width: 100%;
  display: flex;
`;
const SubHeaderContent = styled(Col)`
  display: flex;
  width: 100%;
  justify-content: space-evenly;
`;

const StyledTab = styled(Tabs)`
  width: 100%;
.ant-tabs-nav-list{
  width: 100%;
  display: flex;
  justify-content:space-around;
  @media screen and (max-width: 768px) {
    width: 100%;
    display: flex;
  }
}
.ant-tabs-tab{
  font-size: 1.5rem;
  @media screen and (max-width: 768px) {
    font-size:1rem;
    margin:0;
  }
}

`

const Dashboard: FC = (props: any) => {
  const history = useHistory();
  
  let key = '';
  const url = window.location.href;
  key = url.split("dashboard/")[1];

  const onChange = (key: string) => {
    history.push(`/dashboard/${key}`);
  };
  return (
    <>
      <Container>
        <HeaderComponent />
        <div style={{ background: '#F7F7F7', flex: 1 }}>
          <Col
            md={{ span: 18, offset: 3 }} sm={{ span: 22, offset: 1 }}
            // span={18}
            // offset={3}
            style={{
              display: "flex",
              flexDirection: "column",
              marginBottom: "2rem",
              flex: 1,
            }}
          >
            <SubHeaderSection>
              <SubHeaderContent>
                <StyledTab defaultActiveKey={key} tabPosition="top" onChange={onChange}>
                  <TabPane tab="Orders" key="orders">
                  </TabPane>
                  <TabPane tab="Inbox" key="inbox">
                  </TabPane>
                  <TabPane tab="My Printers" key="printers">
                  </TabPane>
                  <TabPane tab="My Designs" key="designs">
                  </TabPane>
                  <TabPane tab="Profile" key="profile">
                  </TabPane>
                </StyledTab>
                {/* <SubHeaderItem size="true">
                  <NavLink
                    to={`${props.match.path}/orders`}
                    activeStyle={{ borderBottom: "2px solid #1196DD" }}
                  >
                    orders
                  </NavLink>
                </SubHeaderItem>
                <SubHeaderItem size="true">
                  <NavLink
                    to={`${props.match.path}/inbox`}
                    activeStyle={{ borderBottom: "2px solid #1196DD" }}
                  >
                    inbox
                  </NavLink>
                </SubHeaderItem>
                <SubHeaderItem size="true">
                  <NavLink
                    to={`${props.match.path}/printers`}
                    activeStyle={{ borderBottom: "2px solid #1196DD" }}
                    isActive={(s: any, location) =>
                      [
                        "/dashboard/add/new/printer",
                        "/dashboard/printers",
                      ].includes(location.pathname)
                    }
                  >
                    My printers
                  </NavLink>
                </SubHeaderItem>
                <SubHeaderItem size="true">
                  <NavLink
                    to={`${props.match.path}/designs`}
                    activeStyle={{ borderBottom: "2px solid #1196DD" }}
                    isActive={(s: any, location) =>
                      [
                        "/dashboard/designs",
                        "/dashboard/upload/designs",
                      ].includes(location.pathname)
                    }
                  >
                    my designs
                  </NavLink>
                </SubHeaderItem>
                <SubHeaderItem size="true">
                  <NavLink
                    to={`${props.match.path}/profile`}
                    activeStyle={{ borderBottom: "2px solid #1196DD" }}
                  >
                    profile
                  </NavLink>
                  </SubHeaderItem> */}
              </SubHeaderContent>
            </SubHeaderSection>
            <Switch>
              <Route
                path={`${props.match.path}/inbox`}
                exact
                component={InboxPage}
              />
              <Route
                path={`${props.match.path}/orders`}
                exact
                component={OrderPageNew}
              />
              <Route
                exact
                path={`${props.match.path}/printers`}
                component={MyPrinters}
              />
              <Route
                path={`${props.match.path}/printers/:id`}
                component={SinglePrinterPage}
              />

              <Route
                exact
                path={`${props.match.path}/add/new/printer`}
                component={AddNewPrinter}
              />
              <Route
                path={`${props.match.path}/add/new/printer/:id`}
                component={EditPrinter}
              />
              <Route
                path={`${props.match.path}/designs`}
                exact
                component={MyDesigns}
              />
              <Route
                path={`${props.match.path}/design/addnew`}
                component={UploadNewDesignPage}
                exact
              />
              <Route
                path={`${props.match.path}/design/publish`}
                component={UploadNewPublish}
                exact
              />
              <Route
                path={`${props.match.path}/design/info`}
                component={InfoPage}
                exact
              />
              <Route
                path={`${props.match.path}/design/thumbnail`}
                component={UploadDesignThumbnail}
                exact
              />
              <Route
                path={`${props.match.path}/design/select`}
                component={UploadNewPublish}
                exact
              />
              <Route
                path={`${props.match.path}/select/printer`}
                component={UploadNewDesignSelectPage}
              />
              <Route
                path={`${props.match.path}/profile`}
                component={ProfileScreen}
              />
            </Switch>
          </Col>
        </div>
        <FooterPublic3D />
      </Container>
    </>
  );
};

export default withRouter(Dashboard);
